// extracted by mini-css-extract-plugin
module.exports = {"stargazers":"Stargazers_stargazers__3VWEY","star":"Stargazers_star__wsiUM","count":"Stargazers_count__2Vq_V"};